<template>
  <card id="canvasCard">
    <template slot="header">
      <h5 class="card-title pb-5p">{{ i18nValues["rfmMap"] }}</h5>
      <canvas
        id="c"
        :width="maxCanvasWidth"
        :height="canvasHeight"
        @mousemove="canvasMouseMove"
        style="margin-top: 15px; white-space: pre-wrap;"
      ></canvas>
    </template>
  </card>
</template>
<script>
export default {
  name: "RFMMapv2Section",
  props: {
    rfmMap: Array,
    rfmMapDetail: Array,
    rfmMapNames: Array,
  },
  components: {},
  mounted() {
    var c = document.getElementById("c");
    var ctx = c.getContext("2d");
    this.vueCanvas = ctx;

    this.timer = setInterval(() => {
      this.draw();
    }, 50);
  },
  beforeDestroy() { 
    clearInterval(this.timer);
},
  created: function() {
    this.buildData();
  },
  methods: {
    draw: function() {
      if (!this.vueCanvas) {
        return;
      }

      this.vueCanvas.clearRect(
        0,
        0,
        this.maxCanvasWidth,
        this.canvasHeight + 200
      );
      this.vueCanvas.fillStyle = "white";
      this.vueCanvas.fillRect(0, 0, this.canvasWidth, this.canvasHeight + 200);

      var minX = this.RFMData[0].xFrom;
      var maxX = this.RFMData[0].xTo;
      var minY = this.RFMData[0].yFrom;
      var maxY = this.RFMData[0].yTo;

      for (var i = 1; i < this.RFMData.length; i++) {
        var currentValue = this.RFMData[i];
        if (minX > currentValue.xFrom) {
          minX = currentValue.xFrom;
        }
        if (maxX < currentValue.xTo) {
          maxX = currentValue.xTo;
        }
        if (minY > currentValue.yFrom) {
          minY = currentValue.yFrom;
        }
        if (maxY < currentValue.yTo) {
          maxY = currentValue.yTo;
        }
      }

      this.drawAreas(minX, maxX, minY, maxY);
      this.drawAxis(minX, maxX, minY, maxY);
      this.drawAreasTexts();
      this.drawTooltip();
    },
    drawAreas: function(minX, maxX, minY, maxY) {
      var newAreasRectanglesDrawn = [];
      for (var i = 0; i < this.RFMData.length; i++) {
        var currentValue = this.RFMData[i];
        var areaDrawn = this.drawArea(currentValue, minX, maxX, minY, maxY);
        newAreasRectanglesDrawn.push(areaDrawn);
      }

      this.areasRectanglesDrawn = newAreasRectanglesDrawn;
    },
    drawArea: function(area, minX, maxX, minY, maxY) {
      var canvasCard = document.getElementById("canvasCard");
      var width =
        canvasCard.offsetWidth - this.widthOffsetFix - this.leftAxisWidth;
      var height = this.canvasHeight - this.bottomAxisHeight;

      var xRange = maxX - minX;
      var yRange = maxY - minY;

      this.vueCanvas.fillStyle = area.color;

      var xStart = ((area.xFrom - minX) / xRange) * width;
      var xEnd = ((area.xTo - minX) / xRange) * width;
      var yStart = ((area.yFrom - minY) / yRange) * height;
      var yEnd = ((area.yTo - minY) / yRange) * height;

      var areaWidth = xEnd - xStart - this.areasSeparation;
      var areaHeight = yEnd - yStart - this.areasSeparation;
      var areaXStart = xStart + this.leftAxisWidth + this.areasSeparation;
      var areaYStart = height - areaHeight - (yStart + this.areasSeparation);

      this.vueCanvas.fillRect(areaXStart, areaYStart, areaWidth, areaHeight);

      return {
        xStart: areaXStart,
        yStart: areaYStart,
        width: areaWidth,
        height: areaHeight,
        area: area,
      };
    },
    drawAreasTexts: function() {
      var textsToWrite = [];
      var maxFontSize = 13;

      for (var i = 0; i < this.areasRectanglesDrawn.length; i++) {
        var currentArea = this.areasRectanglesDrawn[i];
        var maxSizeLines = this.getMaxSizeLines(currentArea.area.text, maxFontSize, currentArea.width - this.textMarginRight*2);
        
        if (maxFontSize > maxSizeLines.fontSize) {
          maxFontSize = maxSizeLines.fontSize;
        }

        textsToWrite.push(maxSizeLines);
      }
      
      this.vueCanvas.font = 400 + " " + maxFontSize + "px Montserrat";
      this.vueCanvas.fillStyle = "#FFF";

      for (var i = 0; i < this.areasRectanglesDrawn.length; i++) {
        var currentArea = this.areasRectanglesDrawn[i];
        var area = currentArea.area;
        var areaWidth = currentArea.width;
        var areaXStart = currentArea.xStart;
        var areaYStart = currentArea.yStart;

        for (var j = 0; j < textsToWrite[i].lines.length; j++) {
          var text = textsToWrite[i].lines[j];
          var textMetrics = this.vueCanvas.measureText(text);
          this.vueCanvas.fillText(
            text,
            areaXStart + areaWidth - textMetrics.width - this.textMarginRight,
            areaYStart + maxFontSize + this.textMarginTop + j*(maxFontSize + this.textMarginBetweenLines)
          );
        }
      }
    },
    drawAxis(minX, maxX, minY, maxY) {
      var canvasCard = document.getElementById("canvasCard");
      var width =
        canvasCard.offsetWidth - this.widthOffsetFix - this.leftAxisWidth;
      var height = this.canvasHeight - this.bottomAxisHeight;

      var xRange = maxX - minX;
      var yRange = maxY - minY;

      var xUnitWidth = (1 / xRange) * width;
      var yUnitWidth = (1 / yRange) * height;

      var fontSize = 13;
      this.vueCanvas.font = 400 + " " + fontSize + "px Montserrat";
      this.vueCanvas.fillStyle = "#999";

      for (var x = minX; x < maxX; x++) {
        var xPos = ((x - minX) / xRange) * width + this.leftAxisWidth;
        var textMetrics = this.vueCanvas.measureText(x);
        this.vueCanvas.fillText(
          x,
          xPos + xUnitWidth / 2 - textMetrics.width / 2,
          height + this.bottomAxisHeight / 2 - 5
        );
      }

      for (var y = minY; y < maxY; y++) {
        var yPos = ((y - minY) / yRange) * height;
        var textMetrics = this.vueCanvas.measureText(x);
        this.vueCanvas.fillText(y, 25, height - yPos - yUnitWidth / 2);
      }

      this.vueCanvas.fillStyle = "#777";
      var textMetrics = this.vueCanvas.measureText("Recency Score");
      this.vueCanvas.fillText(
        "Recency Score",
        width / 2 - textMetrics.width / 2,
        height + this.bottomAxisHeight / 2 + 13
      );

      this.vueCanvas.save();
      this.vueCanvas.rotate(-Math.PI / 2);
      var textMetrics = this.vueCanvas.measureText("Frequency Score");
      this.vueCanvas.fillText(
        "Frequency Score",
        -height / 2 - textMetrics.width / 2,
        12
      );
      this.vueCanvas.restore();
    },
    canvasMouseMove(e) {
      var x = e.offsetX;
      var y = e.offsetY;
      var areaFound = false;

      for (var i = 0; i < this.areasRectanglesDrawn.length; i++) {
        var currentArea = this.areasRectanglesDrawn[i];

        if (
          currentArea.xStart < x &&
          currentArea.xStart + currentArea.width > x &&
          currentArea.yStart < y &&
          currentArea.yStart + currentArea.height > y
        ) {
          this.areaOver = currentArea;
          areaFound = true;
          break;
        }
      }

      if (!areaFound) {
        this.areaOver = null;
      }
    },
    drawTooltip() {
      if (!this.areaOver) {
        return;
      }
      this.vueCanvas.fillStyle = "#222d";
      var fontSize = 11;
      this.vueCanvas.font = 400 + " " + fontSize + "px Montserrat";
      var linesVerticalPadding = 7;

      var canvasCard = document.getElementById("canvasCard");

      var x = this.areaOver.xStart + this.areaOver.width / 2;
      var y = this.areaOver.yStart + this.areaOver.height / 2;
      var width = this.getDetailsTooltipWidth(
        this.areaOver.area.tooltipDetails,
        linesVerticalPadding
      );
      var height =
        this.areaOver.area.tooltipDetails.length *
          (fontSize + linesVerticalPadding) +
        linesVerticalPadding +
        3;

      if (x > canvasCard.offsetWidth / 2) {
        x = x - width;
      }
      if (y > canvasCard.offsetHeight / 2) {
        y = y - height;
      }

      this.vueCanvas.fillRect(x, y, width, height);

      this.vueCanvas.fillStyle = "#FFF";

      for (var i = 0; i < this.areaOver.area.tooltipDetails.length; i++) {
        var detail = this.areaOver.area.tooltipDetails[i];
        this.vueCanvas.fillText(
          detail.label,
          x + linesVerticalPadding,
          y + (fontSize + linesVerticalPadding) * (i + 1)
        );

        var textMetrics = this.vueCanvas.measureText(detail.value);
        this.vueCanvas.fillText(
          detail.value,
          x + width - textMetrics.width - linesVerticalPadding,
          y + (fontSize + linesVerticalPadding) * (i + 1)
        );
      }
    },
    getDetailsTooltipWidth(tooltipDetails, padding) {
      var labelValueSeparation = 20;
      var retval = 0;

      for (var i = 0; i < tooltipDetails.length; i++) {
        var detail = tooltipDetails[i];
        var textMetricsLabel = this.vueCanvas.measureText(detail.label);
        var textMetricsValue = this.vueCanvas.measureText(detail.value);

        var current =
          textMetricsLabel.width +
          textMetricsValue.width +
          labelValueSeparation +
          padding * 2;
        if (current > retval) {
          retval = current;
        }
      }

      return retval;
    },
    buildData() {
      for (let i = 0; i < this.rfmMap.length; i++) {
        this.RFMData.push({
          text: this.rfmMap[i].rfmSegment,
          tooltipDetails: [
            { label: "Cantidad Clientes", value: this.rfmMap[i].customerQty },
            { label: "% del total", value: this.rfmMap[i].percentOfTotal },
            { label: "Avg Recency", value: this.rfmMap[i].avgRecency },
            { label: "Avg Frequency", value: this.rfmMap[i].avgFrequency },
            { label: "Avg Monetary", value: this.rfmMap[i].avgMonetaryValue },
          ],
          xFrom: this.rfmMap[i].xFrom,
          xTo: this.rfmMap[i].xTo,
          yFrom: this.rfmMap[i].yFrom,
          yTo: this.rfmMap[i].yTo,
          color: this.rfmMap[i].color,
        });
      }
    },
    getMaxSizeLines(text, startingFontSize, maxWidth) {
      var fit = false;
      var fontSize = startingFontSize;
      this.vueCanvas.font = 400 + " " + fontSize + "px Montserrat";
      var textLines = [text];
      var textMetrics = null;

      while (!fit) {
        fit = true;
        for (var i = 0; i < textLines.length; i++) {
            var line = textLines[i];
            textMetrics = this.vueCanvas.measureText(line.toString());
            if (textMetrics.width > maxWidth) {
                fit = false;
                break;
            }
        }

        if (!fit) {
            var textSplited = false;
            for (i = textLines.length - 1; i >= 0; i--) {
                line = textLines[i];
                var index = line.lastIndexOf(" ");
                if (index > 0) {
                    textLines.splice(i, 1, line.substring(0, index));
                    textLines.splice(i + 1, 0, line.substring(index + 1))
                    textSplited = true;
                }
            }

            if (!textSplited) {
                fontSize--;
                this.vueCanvas.font = 400 + " " + fontSize + "px Montserrat";
            }
        }     
      }
      
      return {
        "fontSize": fontSize,
        "lines": textLines
      };
    }
  },
  data() {
    return {
      vueCanvas: null,
      maxCanvasWidth: 1500,
      leftAxisWidth: 40,
      bottomAxisHeight: 40,
      canvasHeight: 450,
      widthOffsetFix: 25,
      areasSeparation: 2,
      textMarginRight: 10,
      textMarginTop: 10,
      textMarginBetweenLines: 5,
      areaOver: null,
      areasRectanglesDrawn: [],
      RFMData: [],
    };
  },
};
</script>
<style scoped></style>
